export const races = [
  {
    "date": "Sat, Sep 5",
    "name": "Terrapin Time Trial",
    "location": "Greenbelt, MD",
    "type": "TT"
  },
  {
    "date": "Sat, Sep 12",
    "name": "Cavalier Invitational",
    "location": "Earlysville, VA",
    "type": "Club"
  },
  {
    "date": "Sat, Sep 19",
    "name": "Old Bay Invitational",
    "location": "Kent Island, MD",
    "type": "Club"
  },
  {
    "date": "Fri, Oct 2",
    "name": "Paul Short Run",
    "location": "Bethlehem, PA",
    "type": "D1"
  },
  {
    "date": "Sat, Oct 17",
    "name": "NIRCA Mid-Atlantic Regionals",
    "location": "Earlysville, VA",
    "type": "Club"
  },
  {
    "date": "Sat, Nov 7",
    "name": "NIRCA Cross Country Nationals",
    "location": "Shelbyville, IN",
    "type": "Club"
  },
  {
    "date": "Sun, Dec 6",
    "name": "Blue & Grey Half Marathon",
    "location": "Fredericksburg, VA",
    "type": "Road"
  }
];
